module.exports = __webpack_public_path__ + "img/unblock_notification_2.952d01a3.png";